<script lang="ts" setup>
defineProps<{
  content: string;
}>();
</script>

<template>
  <MDC :value="content" class="baseComplexText" />
</template>

<style lang="scss">
.baseComplexText {
  p {
    margin: 0;

    & + p {
      margin-top: 1.5em;
    }
  }

  strong,
  b {
    font-variation-settings: 'wght' 700;
  }
}
</style>
